import { LessonDto, State } from "../../interfaces";
import { Paginated, SelectListDto } from "../../models";
import {
  ADD_LESSON,
  ADD_LESSON_ERROR,
  ADD_LESSON_SUCCESS,
  ActionTypes,
  DELETE_LESSON,
  DELETE_LESSON_CONSENT,
  DELETE_LESSON_ERROR,
  DELETE_LESSON_SUCCESS,
  GET_LESSON,
  GET_LESSONS,
  GET_LESSONS_ERROR,
  GET_LESSONS_SUCCESS,
  GET_LESSON_DETAIL,
  GET_LESSON_DETAIL_ERROR,
  GET_LESSON_DETAIL_SUCCESS,
  GET_LESSON_ERROR,
  GET_LESSON_LIST_BY_CHAPTER,
  GET_LESSON_LIST_BY_CHAPTER_ERROR,
  GET_LESSON_LIST_BY_CHAPTER_SUCCESS,
  GET_LESSON_SUCCESS,
  RESET_LESSON_LIST_BY_CHAPTER,
  UPDATE_LESSON,
  UPDATE_LESSON_ERROR,
  UPDATE_LESSON_SUCCESS,
} from "./actionTypes";

export class LessonState {
  lessons!: State<Paginated<LessonDto>>;
  lesson!: State<LessonDto>;
  lessonDetail!: State<LessonDto>;
  addLesson!: State<any>;
  updateLesson!: State<any>;
  deleteLesson!: State<any>;
  lessonSelectListByChapter: State<SelectListDto[]>;
  constructor() {
    this.lessons = {
      loading: false,
      error: null,
      success: false,
    };
    this.lesson = {
      loading: false,
      error: null,
      success: false,
    };
    this.addLesson = {
      loading: false,
      error: null,
      success: false,
    };
    this.updateLesson = {
      loading: false,
      error: null,
      success: false,
    };
    this.deleteLesson = {
      loading: false,
      error: null,
      success: false,
    };
    this.lessonDetail = {
      loading: false,
      error: null,
      success: false,
    };
    this.lessonSelectListByChapter = {
      loading: false,
      error: null,
      success: false,
    };
  }
}

const initialState: LessonState = new LessonState();

export const lesson = (
  state: LessonState = initialState,
  action: ActionTypes
) => {
  switch (action.type) {
    case GET_LESSONS:
      state = {
        ...state,
        lessons: {
          ...state.lessons,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_LESSONS_SUCCESS:
      state = {
        ...state,
        lessons: {
          ...state.lessons,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_LESSONS_ERROR:
      state = {
        ...state,
        lessons: {
          ...state.lessons,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_LESSON:
      state = {
        ...state,
        lesson: {
          ...state.lesson,
          loading: true,
          success: false,
          error: null,
        },
        addLesson: {
          ...state.addLesson,
          loading: false,
          success: false,
          error: null,
        },
        updateLesson: {
          ...state.updateLesson,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case GET_LESSON_SUCCESS:
      state = {
        ...state,
        lesson: {
          ...state.lesson,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_LESSON_ERROR:
      state = {
        ...state,
        lesson: {
          ...state.lesson,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_LESSON_DETAIL:
      state = {
        ...state,
        lessonDetail: {
          ...state.lessonDetail,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_LESSON_DETAIL_SUCCESS:
      state = {
        ...state,
        lessonDetail: {
          ...state.lessonDetail,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_LESSON_DETAIL_ERROR:
      state = {
        ...state,
        lessonDetail: {
          ...state.lessonDetail,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case ADD_LESSON:
      state = {
        ...state,
        addLesson: {
          ...state.addLesson,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case ADD_LESSON_SUCCESS:
      state = {
        ...state,
        addLesson: {
          ...state.addLesson,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case ADD_LESSON_ERROR:
      state = {
        ...state,
        addLesson: {
          ...state.addLesson,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;

    case UPDATE_LESSON:
      state = {
        ...state,
        updateLesson: {
          ...state.updateLesson,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case UPDATE_LESSON_SUCCESS:
      state = {
        ...state,
        updateLesson: {
          ...state.updateLesson,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case UPDATE_LESSON_ERROR:
      state = {
        ...state,
        updateLesson: {
          ...state.updateLesson,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case DELETE_LESSON_CONSENT:
      state = {
        ...state,
        deleteLesson: {
          ...state.deleteLesson,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_LESSON:
      state = {
        ...state,
        deleteLesson: {
          ...state.deleteLesson,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_LESSON_SUCCESS:
      state = {
        ...state,
        deleteLesson: {
          ...state.deleteLesson,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case DELETE_LESSON_ERROR:
      state = {
        ...state,
        deleteLesson: {
          ...state.deleteLesson,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_LESSON_LIST_BY_CHAPTER:
      state = {
        ...state,
        lessonSelectListByChapter: {
          ...state.lessonSelectListByChapter,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_LESSON_LIST_BY_CHAPTER_SUCCESS:
      state = {
        ...state,
        lessonSelectListByChapter: {
          ...state.lessonSelectListByChapter,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_LESSON_LIST_BY_CHAPTER_ERROR:
      state = {
        ...state,
        lessonSelectListByChapter: {
          ...state.lessonSelectListByChapter,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case RESET_LESSON_LIST_BY_CHAPTER:
      state = {
        ...state,
        lessonSelectListByChapter: {
          ...state.lessonSelectListByChapter,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
